<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-text-field
      v-model="form.name"
      :rules="rules.name"
      type="text"
      label="Название"
    />

    <v-text-field
      v-model="form.formula"
      :rules="rules.formula"
      readonly
      type="text"
      label="Формула"
    />

    <v-select
      v-model="form.filterable"
      label="Учавствует в фильтрации"
      :items="[{ text: 'Нет', value: false }, { text: 'Да', value: true }]"
    />

    <v-text-field
      v-model="form.criticalLevel"
      type="number"
      label="Критический уровень"
    />

    <div class="d-flex justify-end">
      <v-btn type="submit" color="primary" dark>Сохранить изменения</v-btn>
    </div>
  </v-form>
</template>

<script>
const createDefaultForm = () => ({
  name: null,
  formula: null,
  filterable: false,
  criticalLevel: 0,
});

const createDefaultRules = () => ({
  name: [
    v => !!v || 'Название обязательно для заполнения',
  ],
  formula: [
    v => !!v || 'Формула обязательна для заполнения',
  ],
});

export default {
  name: 'metric-form',
  model: {
    event: 'change',
    prop: 'input',
  },
  props: {
    data: {
      type: Object,
      default: createDefaultForm,
    },
    isLoading: Boolean,
    isEdit: Boolean,
  },
  data: () => ({
    form: createDefaultForm(),
    rules: createDefaultRules(),
    valid: true,
  }),
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form = {
          ...this.form,
          ...value,
        };
      },
    },
    form: {
      deep: true,
      handler(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', this.form);
      }
    },
  },
};
</script>

<style scoped>

</style>
